// This will auto install plugins
import AttributePlugins from './attribute/PluginSetup.js';
import ColorizerPlugins from './colorizer/PluginSetup.js';
import VariantizerPlugins from './variantizer/PluginSetup.js';
import VisibilizerPlugins from './visibilizer/PluginSetup.js';
import DetailPlugins from './detail/PluginSetup.js';
import TablePlugins from './table/PluginSetup.js';
import ExportPlugins from './export/PluginSetup.js';
import ConditionPlugins from './condition/PluginSetup.js';

/**
 * Install all the plugins in this directory.
 * @param {object} opts for future use
 */
export default {
  install: opts => {
    AttributePlugins.install(opts);
    ColorizerPlugins.install(opts);
    VariantizerPlugins.install(opts);
    VisibilizerPlugins.install(opts);
    DetailPlugins.install(opts);
    TablePlugins.install(opts);
    ExportPlugins.install(opts);
    ConditionPlugins.install(opts);
  }
};